module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cart-header"
  }, [_c('span', {
    staticClass: "cart-title"
  }, [_vm._v("Your Cart")]), _vm._v(" "), _c('a', {
    staticClass: "hide-cart",
    on: {
      "click": function($event) {
        return _vm.$emit('hideCart')
      }
    }
  }, [_vm._v("Hide Cart")])]), _vm._v(" "), (_vm.cartItems.length < 1) ? _c('div', {
    staticClass: "cart-empty"
  }, [_vm._v("Your cart is empty")]) : _c('div', {
    staticClass: "cart-listing"
  }, [_vm._l((_vm.cartItems), function(item) {
    return _c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "cart-control",
      on: {
        "click": function($event) {
          return _vm.removeFromCart(item.id)
        }
      }
    }, [_c('icons', {
      attrs: {
        "icon": "close"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-description"
    }, [_vm._v("\n                " + _vm._s(item.name) + " -\n                " + _vm._s(item.description) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "cart-price"
    }, [_vm._v("\n                $" + _vm._s(item.price) + "\n            ")])])
  }), _vm._v(" "), _c('button', {
    staticClass: "button btn-sm btn-primary add-to-cart-btn",
    on: {
      "click": function($event) {
        return _vm.goToReview()
      }
    }
  }, [_vm._v("Checkout")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57fe8cc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupCart.vue
// module id = 222
// module chunks = 1